import {
  Menu,
} from '@/internal';

export default (payload = {}) => {
  return new Menu({
    title: 'Community',
    open: true,
    menuItems: [
      {
        href: 'https://www.facebook.com/groups/444623373019965',
        icon: 'facebook',
        iconPack: 'fa-brands',
        target: '_blank',
        title: 'FB Group',
      },
      {
        title: 'Roadmap',
        icon: 'map',
        onClick: async () => {
          window.FrillWidget.viewSection('roadmap');
          window.FrillWidget.open();
        }
      },
      {
        title: 'Share an Idea',
        icon: 'lightbulb-exclamation-on',
        onClick: async () => {
          window.FrillIdeaWidget.open();
        }
      },
      // {
      //   title: 'Feedback',
      //   icon: 'star',
      //   onClick: async () => {
      //     // window.FrillSurvey.open();
      //
      //   }
      // },
      // {
      //   route: window.app.findRouteByName('marketplace/index'),
      // },
    ],
  });
};
